import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  FileField,
  FilterOptionSelect,
  IndicatorField
} from 'imports/ComponentsImports';

import {
  LoadingDialog,
  PrimaryButton,
  PrimaryColor1
} from 'imports/DesignImports';

import {
  CircularProgress,
  Divider,
  TextField
} from 'material-ui';

const styles = {
  latoFont: {
    fontFamily: 'Lato',
    fontWeight: '300',
    color: PrimaryColor1,
  },
  finishSectionContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '2em 0',
  },
  textArea: {
    overflow: 'scroll',
    fontWeight: '300',
    color: PrimaryColor1,
  },
  underline: {
    width: '50%',
    color: PrimaryColor1,
  },
  floatingLabel: {
    color: PrimaryColor1,
  },
}

class EditFileView extends Component {
  constructor(props){
    super(props);
    this.state = {
      token: this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
      project: {},
      error: false,
      loadingData: false, 
      loadingMessage: "",
      problem: "",
      solution: "",
      objectives: "",
      characteristics: "",
      benefits: "",
      error: false,
    }
  }

  componentDidMount(){
    this.getProject();
  }
  
  getProject = () => {
    this.openLoadingMessage("Estamos recargando la información del proyecto")
    const connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.get(routes.oneProjectFullInformation(this.props.location.state.project.id))
    .then((response) => {
      this.closeLoadingMessage();
      this.setState({
        project: response.data, 
        problem: response.data.information.problem,
        solution: response.data.information.solution,
        objectives: response.data.information.objectives,
        characteristics: response.data.information.characteristics,
        benefits: response.data.information.benefits,
      });
    })
    .catch((error) => {
      this.closeLoadingMessage();
      console.error(error);
    })
  }

  closeLoadingMessage = () => {
    this.setState({loadingData: false, loadingMessage: ""});
  }

  openLoadingMessage = (message) => {
    this.setState({loadingData: true, loadingMessage: message});
  }

  handleChange = event => {
    this.setState({[event.target.name]: event.target.value});
  };

  handleChangeIndicator = (event, newValue, position) => {
    let newState = this.state;
    newState.indicators[position].value = newValue;
    this.setState(newState);
  }

  updateProjectInfo = async () => {
    this.openLoadingMessage("Actualizando la información del proyecto");
    const projectId = this.props.location.state.project.id;
    const token = this.props.cookies.get('token');
    const { problem, solution, objectives, characteristics, benefits } = this.state;
    const payload = {
      problem,
      benefits,
      solution,
      objectives,
      characteristics
    }
    try {
      const connection = axios.create({
        baseURL: routes.host,
        headers: {'Authorization': "Token "+ token}
      });
      const request = await connection.put(routes.updateProjectInfo(projectId), payload);
      const response = request;
      this.closeLoadingMessage();
    } catch (error) {
      this.closeLoadingMessage();
      this.setState({error: true});
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.state.loadingData ? <LoadingDialog message={this.state.loadingMessage} /> : null}
        {this.state.project.information && (
          <div>
            <h1>Edición del proyecto {this.state.project.information.name}</h1>
            <hr />
            <div style={{margin:'1em 2em'}}>
              <h2>1. Información del proyecto</h2>
              <h3>1.1 Información general</h3>
              <div style={{ display: 'flex', flexWrap: 'wrap'}}>
                <TextField
                  inputStyle={styles.latoFont}
                  disabled={true}
                  defaultValue={this.state.project.information.name}
                  floatingLabelText="Nombre"
                  floatingLabelFixed={true}
                  floatingLabelStyle={styles.floatingLabel}
                  style={{width:'50%'}}
                  underlineStyle={styles.underline}
                />
                <TextField
                  inputStyle={styles.latoFont}
                  disabled={true}
                  defaultValue={`${this.state.project.information.leader_first_name} ${this.state.project.information.leader_last_name}`}
                  floatingLabelText="Lider"
                  floatingLabelFixed={true}
                  floatingLabelStyle={styles.floatingLabel}
                  style={{width:'50%'}}
                  underlineStyle={styles.underline}
                />
                <TextField
                  inputStyle={styles.latoFont}
                  disabled={true}
                  defaultValue={this.state.project.information.leader_email}
                  floatingLabelText="Email líder"
                  floatingLabelFixed={true}
                  floatingLabelStyle={styles.floatingLabel}
                  style={{width:'50%'}}
                  underlineStyle={styles.underline}
                />
                <TextField
                  inputStyle={styles.latoFont}
                  disabled={true}
                  defaultValue={`${this.state.project.information.sponsor_first_name} ${this.state.project.information.sponsor_last_name}`}
                  floatingLabelText="Sponsor"
                  floatingLabelFixed={true}
                  floatingLabelStyle={styles.floatingLabel}
                  style={{width:'50%'}}
                  underlineStyle={styles.underline}
                />
                <TextField
                  inputStyle={styles.latoFont}
                  disabled={true}
                  defaultValue={this.state.project.information.area.name}
                  floatingLabelText="Área"
                  floatingLabelFixed={true}
                  floatingLabelStyle={styles.floatingLabel}
                  style={{width:'50%'}}
                  underlineStyle={styles.underline}
                />
                <TextField
                  inputStyle={styles.latoFont}
                  disabled={true}
                  defaultValue={(new Date(this.state.project.information.start_date).getFullYear())}
                  floatingLabelText="Año de implementación"
                  floatingLabelFixed={true}
                  floatingLabelStyle={styles.floatingLabel}
                  style={{width:'50%'}}
                  underlineStyle={styles.underline}
                />
              </div>
              <hr />
              <div>
                <h3>1.2 Características</h3>
                <FilterOptionSelect 
                  solutionType={this.state.project.options.filter(option => option.filter_id === 1).map(option => option.option.name)} 
                  novelty={this.state.project.options.find(option => option.filter_id === 11).option.name} 
                  benefitType={this.state.project.options.filter(option => option.filter_id === 21).map(option => option.option.name)} 
                />
              </div>
              <hr />
              <div>
                <h3>1.3 Solución y beneficios</h3>
                <TextField
                  underlineStyle={styles.underline}
                  floatingLabelStyle={styles.floatingLabel}
                  textareaStyle={styles.textArea}
                  inputStyle={{...styles.latoFont, ...{marginLeft: '1em'}}}
                  defaultValue={this.state.problem}
                  floatingLabelText="Problema u oportunidad"
                  floatingLabelFixed={true}
                  fullWidth={true}
                  rows={3}
                  rowsMax={5}
                  multiLine={true}
                  name="problem"
                  onChange={(event) => this.handleChange(event)}
                />
                <TextField
                  underlineStyle={styles.underline}
                  floatingLabelStyle={styles.floatingLabel}
                  textareaStyle={styles.textArea}
                  inputStyle={{...styles.latoFont, ...{marginLeft: '1em'}}}
                  defaultValue={this.state.solution}
                  floatingLabelText="Descripción de la solución"
                  floatingLabelFixed={true}
                  fullWidth={true}
                  rows={3}
                  rowsMax={5}
                  multiLine={true}
                  name="solution"
                  onChange={(event) => this.handleChange(event)}
                />
                <TextField
                  underlineStyle={styles.underline}
                  floatingLabelStyle={styles.floatingLabel}
                  textareaStyle={styles.textArea}
                  inputStyle={{...styles.latoFont, ...{marginLeft: '1em'}}}
                  defaultValue={this.state.objectives}
                  floatingLabelText="Objetivos de la solución"
                  floatingLabelFixed={true}
                  fullWidth={true}
                  rows={3}
                  rowsMax={5}
                  multiLine={true}
                  name="objectives"
                  onChange={(event) => this.handleChange(event)}
                />
                <TextField
                  underlineStyle={styles.underline}
                  floatingLabelStyle={styles.floatingLabel}
                  textareaStyle={styles.textArea}
                  inputStyle={{...styles.latoFont, ...{marginLeft: '1em'}}}
                  defaultValue={this.state.characteristics}
                  floatingLabelText="Características de la solución"
                  floatingLabelFixed={true}
                  fullWidth={true}
                  rows={3}
                  rowsMax={5}
                  multiLine={true}
                  name="characteristics"
                  onChange={(event) => this.handleChange(event)}
                />
                <TextField
                  underlineStyle={styles.underline}
                  floatingLabelStyle={styles.floatingLabel}
                  textareaStyle={styles.textArea}
                  inputStyle={{...styles.latoFont, ...{marginLeft: '1em'}}}
                  defaultValue={this.state.benefits}
                  floatingLabelText="Beneficios"
                  floatingLabelFixed={true}
                  fullWidth={true}
                  rows={3}
                  rowsMax={5}
                  multiLine={true}
                  name="benefits"
                  onChange={(event) => this.handleChange(event)}
                />
                {this.state.error && (
                  <p>
                    <span style={{color: "red"}}>Ocurrió un error actualizando la información del proyecto</span>
                  </p>
                )}
                <PrimaryButton label="Actualizar información" onClick={() => this.updateProjectInfo()} />
              </div>
              <hr />
              <div>
                <h2>2. Cálculo del proyecto</h2>
                <h3>2.1. Resultados</h3>
                {this.state.user && (
                  <IndicatorField
                    token={this.state.token}
                    indicator={this.state.user.indicator}
                    currency={this.state.user.currency}
                    projectId={this.state.project.id}
                    onChange={(event, newValue, type) => this.handleChange(event, newValue, type)}
                  />
                )}
                <span style={{color: "red"}}>*Nota: Al actualizar alguno de estos valores, se hace la actualiación inmediata de la información</span>
              </div>
              <hr />
              <div>
                <h4>Archivos</h4>
                <FileField
                  userPosition={"Líder de proyecto"}
                  projectId={this.state.project.id} token={this.state.token}
                  downloadedFileName={"Método-proyecto-" + this.state.project.information.name}
                  uploadType='method'
                  currentFileName={this.state.project.method_file_name} 
                />
                <h3>2.3 Hoja de cálculo (xlsx o xls)</h3>
                <FileField
                  userPosition={"Líder de proyecto"}
                  projectId={this.state.project.id} token={this.state.token}
                  downloadedFileName={"Cálculo-proyecto-" + this.state.project.information.name}
                  uploadType='calculation'
                  currentFileName={this.state.project.calculation_file_name} />
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }

}

export default withCookies(withRouter(EditFileView));



// WEBPACK FOOTER //
// ./src/views/files/EditFileView.js